<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="Reload" width="20" height="20"
  ><path
    d="M8.354 1.01a6.98 6.98 0 0 0-.938.013v.002a7.005 7.005 0 0 0-6.047 9.215 7.006 7.006 0 0 0 8.03 4.62 7.006 7.006 0 0 0 5.581-7.393.5.5 0 1 0-.998.074A5.992 5.992 0 0 1 9.2 13.877a5.994 5.994 0 0 1-6.883-3.959 5.992 5.992 0 0 1 3.07-7.32 5.993 5.993 0 0 1 7.089 1.41H11.5a.5.5 0 1 0 0 1h2a.5.5 0 0 0 .5-.5v-2A.5.5 0 0 0 13.492 2a.5.5 0 0 0-.492.508v.617A7.004 7.004 0 0 0 8.354 1.01z"
    color="#000"
    font-family="sans-serif"
    font-weight="400"
    overflow="visible"
    style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;white-space:normal;isolation:auto;mix-blend-mode:normal;solid-color:#000;solid-opacity:1"
    fill="#ffffff"
    class="color000000 svgShape"
  /></svg
>
